var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconStreamPlay = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3385 6.78854C10.8332 6.49911 11.0061 6.3101 11.0061 5.99705C11.0061 5.68399 10.8332 5.49498 10.3385 5.21146L3.38843 1.22445C3.15 1.0886 2.94735 1 2.70892 1C2.26784 1 1.99365 1.33077 1.99365 1.84465V10.1494C1.99365 10.6633 2.26784 11 2.70892 11C2.94735 11 3.15 10.9055 3.38843 10.7696L10.3385 6.78854ZM3.8835 11.6385C3.62652 11.7849 3.22734 12 2.70892 12C2.21265 12 1.74443 11.7997 1.41769 11.4076C1.10737 11.0353 0.993652 10.5755 0.993652 10.1494V1.84465C0.993652 1.41845 1.10754 0.957824 1.42085 0.58563C1.75022 0.194348 2.2186 0 2.70892 0C3.21648 0 3.60767 0.198434 3.8835 0.355602L3.88603 0.357044L10.8357 4.34383C11.0982 4.49426 11.3923 4.68176 11.6151 4.94012C11.8847 5.2528 12.0061 5.61336 12.0061 5.99705C12.0061 6.38124 11.8845 6.74042 11.617 7.05245C11.3963 7.30994 11.1044 7.49898 10.8434 7.65168L10.8355 7.6563L3.8835 11.6385Z",
    fill: "#09090A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.44197 9.46993C3.6128 9.46993 3.758 9.40435 3.92882 9.31007L8.90838 6.54732C9.26284 6.34647 9.38669 6.2153 9.38669 5.99805C9.38669 5.7808 9.26284 5.64964 8.90838 5.45288L3.92882 2.68604C3.758 2.59176 3.6128 2.53027 3.44197 2.53027C3.12595 2.53027 2.9295 2.75982 2.9295 3.11643V8.87967C2.9295 9.23629 3.12595 9.46993 3.44197 9.46993Z",
    fill: "#09090A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconStreamPlay);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-stream-play.4c20e7ced4f16ed05a3511c6e7be1080.svg";